export default __webpack_public_path__ + "static/media/kid13.db70d18c.jpg";